import React from 'react';
import {
  Box, Container, Typography, Grid, Card, CardContent,
  Avatar, Rating, Chip,
} from '@mui/material';
import { FormatQuote } from '@mui/icons-material';

const testimonials = [
  {
    name: 'Marco Rossi',
    role: 'Gestor de operações',
    company: 'SpeedEx Deliveries',
    platform: 'Plataforma de estafetas',
    platformColor: '#16a34a',
    avatar: 'MR',
    avatarBg: 'linear-gradient(135deg, #16a34a, #15803d)',
    rating: 5,
    quote:
      'A NeoDrive mudou por completo a forma como tratamos a folha semanal. O que antes ocupava um dia inteiro à equipa agora leva cerca de 20 minutos. A exportação SEPA é decisiva — um clique e os 300 estafetas ficam pagos.',
  },
  {
    name: 'Sofia Andrade',
    role: 'CEO e fundadora',
    company: 'Rota Rápida Logística',
    platform: 'Plataforma de estafetas',
    platformColor: '#16a34a',
    avatar: 'SA',
    avatarBg: 'linear-gradient(135deg, #1e40af, #2563eb)',
    rating: 5,
    quote:
      'A gestão de parceiros é excecional. Vejo exatamente o que cada parceiro deve por semana, gero faturas automaticamente e envio-as por WhatsApp. Os nossos parceiros valorizam a transparência.',
  },
  {
    name: 'Dieter Müller',
    role: 'Diretor de frota',
    company: 'EuroFleet GmbH',
    platform: 'Plataforma de motoristas',
    platformColor: '#ea580c',
    avatar: 'DM',
    avatarBg: 'linear-gradient(135deg, #ea580c, #c2410c)',
    rating: 5,
    quote:
      'Gerir 150 motoristas e veículos em três cidades era caótico antes da NeoDrive. Agora está tudo num só sítio — relatórios de motoristas, rendas de veículos, pagamentos a proprietários. Não consigo imaginar o negócio sem isto.',
  },
];

export default function Testimonials() {
  return (
    <Box
      id="testimonials"
      component="section"
      sx={{
        py: { xs: 8, md: 12 },
        background: 'linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%)',
      }}
    >
      <Container maxWidth="lg">
        {/* Header */}
        <Box sx={{ textAlign: 'center', mb: 7 }}>
          <Chip
            label="TESTEMUNHOS"
            sx={{
              mb: 2,
              background: 'rgba(30,64,175,0.08)',
              color: '#1e40af',
              fontWeight: 700,
              fontSize: '0.7rem',
              letterSpacing: '0.1em',
              height: 28,
            }}
          />
          <Typography variant="h2" sx={{ fontSize: { xs: '2rem', md: '2.75rem' }, mb: 2 }}>
            Equipas de operações em{' '}
            <Box component="span" sx={{
              background: 'linear-gradient(135deg, #ea580c, #1e40af)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}>
              toda a Europa
            </Box>{' '}
            confiam na NeoDrive
          </Typography>
          <Typography sx={{ color: '#64748b', fontSize: '1.05rem', maxWidth: 520, mx: 'auto' }}>
            Empresas de entregas e operadores de frota utilizam a NeoDrive todas as semanas
            para pagar as equipas de forma correta e a tempo.
          </Typography>
        </Box>

        {/* Testimonial cards */}
        <Grid container spacing={3}>
          {testimonials.map((t, i) => (
            <Grid item xs={12} md={4} key={i}>
              <Card
                sx={{
                  height: '100%',
                  border: '1px solid #e2e8f0',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-6px)',
                    boxShadow: '0 16px 40px rgba(0,0,0,0.1)',
                    borderColor: t.platformColor + '40',
                  },
                }}
              >
                <CardContent sx={{ p: 3.5 }}>
                  {/* Quote icon */}
                  <FormatQuote
                    sx={{
                      fontSize: 40,
                      color: t.platformColor,
                      opacity: 0.3,
                      mb: 1,
                      transform: 'scaleX(-1)',
                    }}
                  />

                  {/* Rating */}
                  <Rating value={t.rating} readOnly size="small" sx={{ mb: 2 }} />

                  {/* Quote text */}
                  <Typography
                    sx={{
                      color: '#374151',
                      fontSize: '0.9rem',
                      lineHeight: 1.75,
                      mb: 3,
                      fontStyle: 'italic',
                    }}
                  >
                    &quot;{t.quote}&quot;
                  </Typography>

                  {/* Author */}
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Avatar
                      sx={{
                        background: t.avatarBg,
                        width: 44,
                        height: 44,
                        fontSize: '0.8rem',
                        fontWeight: 700,
                      }}
                    >
                      {t.avatar}
                    </Avatar>
                    <Box sx={{ flex: 1 }}>
                      <Typography sx={{ fontWeight: 700, fontSize: '0.9rem', color: '#0f172a' }}>
                        {t.name}
                      </Typography>
                      <Typography sx={{ fontSize: '0.78rem', color: '#64748b' }}>
                        {t.role} · {t.company}
                      </Typography>
                    </Box>
                    <Chip
                      label={t.platform}
                      size="small"
                      sx={{
                        background: `${t.platformColor}12`,
                        color: t.platformColor,
                        fontWeight: 600,
                        fontSize: '0.65rem',
                        height: 22,
                        border: `1px solid ${t.platformColor}30`,
                      }}
                    />
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Star summary */}
        <Box sx={{
          mt: 6,
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: 'center',
          justifyContent: 'center',
          gap: { xs: 2, md: 5 },
          background: '#fff',
          borderRadius: 3,
          border: '1px solid #e2e8f0',
          p: 3,
        }}>
          {[
            { value: '4,9/5', label: 'Classificação média' },
            { value: '1 200+', label: 'Empresas ativas' },
            { value: '99%', label: 'Recomendariam' },
          ].map((stat, i) => (
            <Box key={i} sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontSize: '1.8rem', fontWeight: 800, color: '#0f172a', letterSpacing: '-0.02em' }}>
                {stat.value}
              </Typography>
              <Typography sx={{ fontSize: '0.85rem', color: '#64748b' }}>{stat.label}</Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
